var _path, _g, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H41C42.6569 0 44 1.34315 44 3V27C44 28.6569 42.6569 30 41 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.66663,
    y: 6.52173,
    width: 26.5434,
    height: 16.937,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.4384,
    y: 9.47266,
    width: 7.00202,
    height: 11.0334,
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1596 14.9902C19.1578 12.8375 20.1822 10.8036 21.9374 9.47449C18.9555 7.21363 14.6735 7.54295 12.1005 10.231C9.52754 12.9191 9.52754 17.0634 12.1005 19.7514C14.6735 22.4395 18.9555 22.7688 21.9374 20.5079C20.1816 19.1784 19.1572 17.1436 19.1596 14.9902Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0241 19.1605V19.619H32.9752V19.1605H32.8707V19.0657H33.1352V19.1605H33.0241ZM33.5373 19.0657V19.619H33.4818V19.2001L33.3951 19.5597H33.3351L33.2485 19.2001V19.619H33.1907V19.0657H33.2707L33.364 19.4609L33.4573 19.0657H33.5373Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7051 14.9905C33.705 17.6769 32.115 20.1275 29.6105 21.3014C27.1059 22.4754 24.1264 22.1666 21.9374 20.5062C23.6918 19.176 24.7162 17.1423 24.7162 14.9895C24.7162 12.8367 23.6918 10.8031 21.9374 9.47281C24.1264 7.81246 27.1059 7.50369 29.6105 8.67763C32.115 9.85158 33.705 12.3021 33.7051 14.9886V14.9905Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardSm);
export default __webpack_public_path__ + "static/media/Mastercard_sm.7fe74db9794ed2ccc71730c28890bd07.svg";
export { ForwardRef as ReactComponent };